import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, withKeys as _withKeys, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5f2db6c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "ion-padding" }

import { computed, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { IonButton, IonContent, IonIcon, IonInput, IonItem, IonPage, IonSpinner } from "@ionic/vue";
import { arrowForwardOutline, eyeOffOutline, eyeOutline, warningOutline } from "ionicons/icons";
import { client, hasError } from "@hotwax/oms-api";
import Logo from "@/components/Logo.vue";
import { showToast } from "@/util";
import { translate } from "@/i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'ResetPassword',
  setup(__props) {

const route = useRoute();
const router = useRouter();

const userId = computed(() => (route.query.userId as string) || "");
const username = computed(() => (route.query.username as string) || "");
const maarg = computed(() => (route.query.maarg as string) || "");

const isLinkValid = computed(() => !!(userId.value && username.value && maarg.value));

const resetPassword = ref("");
const newPassword = ref("");
const newPasswordVerify = ref("");
const showOldPassword = ref(false);
const showPassword = ref(false);
const showConfirm = ref(false);
const isSubmitting = ref(false);
const newPasswordInput = ref<any>(null);
const newPasswordVerifyInput = ref<any>(null);

const isValidPassword = (password: string) => {
  const passwordPattern = /^.*(?=.{5,})(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[!@#$%^&*]).*$/;
  return passwordPattern.test(password);
};

// The emailed link only carries an API host reference (maarg), never a session -
// requests here must not depend on cookies/auth state, so we build an explicit
// baseURL and use the unauthenticated `client` instead of the app-wide `api()` helper.
const getBaseURL = () => {
  if (maarg.value.startsWith("http")) {
    const cleanMaarg = maarg.value.endsWith("/") ? maarg.value.slice(0, -1) : maarg.value;
    return cleanMaarg.includes("/rest/s1") ? cleanMaarg : `${cleanMaarg}/rest/s1/`;
  }
  return `https://${maarg.value}.hotwax.io/rest/s1/`;
};

const inputElement = (inputRef: any) => inputRef?.value?.$el || inputRef?.$el || inputRef?.value || inputRef;

const markTouched = (inputRef: any) => {
  inputElement(inputRef)?.classList.add("ion-touched");
};

const validateNewPasswordVerify = () => {
  const element = inputElement(newPasswordVerifyInput);
  element?.classList.remove("ion-valid");
  element?.classList.remove("ion-invalid");

  if (newPasswordVerify.value === "") return;
  element?.classList.add(newPassword.value === newPasswordVerify.value ? "ion-valid" : "ion-invalid");
};

const validateNewPassword = () => {
  const element = inputElement(newPasswordInput);
  element?.classList.remove("ion-valid");
  element?.classList.remove("ion-invalid");

  if (newPassword.value === "") return;
  element?.classList.add(isValidPassword(newPassword.value) ? "ion-valid" : "ion-invalid");

  if (newPasswordVerify.value !== "") {
    validateNewPasswordVerify();
  }
};

const isSubmitDisabled = computed(() => {
  return isSubmitting.value ||
    !resetPassword.value ||
    !newPassword.value ||
    !newPasswordVerify.value ||
    newPassword.value !== newPasswordVerify.value ||
    !isValidPassword(newPassword.value);
});

const submit = async () => {
  if (isSubmitDisabled.value) return;

  isSubmitting.value = true;
  try {
    const resp = await client({
      baseURL: getBaseURL(),
      url: `admin/users/${userId.value}/changePassword`,
      method: "post",
      data: {
        username: username.value,
        oldPassword: resetPassword.value,
        newPassword: newPassword.value,
        newPasswordVerify: newPasswordVerify.value
      }
    });

    // update#Password reports failures (wrong/missing old password, no permission, weak password) as a public
    // "danger" message with updateSuccessful: false, not as hasError's generic error shape.
    if (!hasError(resp) && resp.data?.updateSuccessful) {
      showToast(translate("Password reset successful. Please login with your new password."));
      router.replace("/login");
    } else {
      throw resp.data;
    }
  } catch (error) {
    showToast(translate("Failed to reset password. Please check your reset password and try again."));
    console.error(error);
  }
  isSubmitting.value = false;
};

const handleSubmit = () => {
  if (!isSubmitDisabled.value) submit();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonContent), null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("form", {
              class: "reset-password-container",
              onKeyup: _cache[9] || (_cache[9] = _withKeys(($event: any) => (handleSubmit()), ["enter"])),
              onSubmit: _cache[10] || (_cache[10] = _withModifiers(() => {}, ["prevent"]))
            }, [
              _createVNode(Logo),
              (!isLinkValid.value)
                ? (_openBlock(), _createElementBlock("section", _hoisted_2, [
                    _createVNode(_unref(IonItem), { lines: "none" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonIcon), {
                          slot: "start",
                          color: "warning",
                          icon: _unref(warningOutline)
                        }, null, 8, ["icon"]),
                        _createElementVNode("h4", null, _toDisplayString(_unref(translate)('Invalid reset password link')), 1)
                      ]),
                      _: 1
                    }),
                    _createElementVNode("p", null, _toDisplayString(_unref(translate)("This password reset link is invalid or incomplete. Please request a new password reset email.")), 1)
                  ]))
                : (_openBlock(), _createElementBlock("section", _hoisted_3, [
                    _createVNode(_unref(IonItem), { lines: "none" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonInput), {
                          label: _unref(translate)('Username'),
                          "label-placement": "stacked",
                          name: "username",
                          "model-value": username.value,
                          id: "username",
                          type: "text",
                          disabled: ""
                        }, null, 8, ["label", "model-value"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonItem), { lines: "full" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonInput), {
                          label: _unref(translate)('Reset password'),
                          "label-placement": "stacked",
                          name: "resetPassword",
                          modelValue: resetPassword.value,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((resetPassword).value = $event)),
                          id: "resetPassword",
                          type: showOldPassword.value ? 'text' : 'password',
                          autocomplete: "off",
                          required: ""
                        }, null, 8, ["label", "modelValue", "type"]),
                        _createVNode(_unref(IonButton), {
                          fill: "clear",
                          slot: "end",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (showOldPassword.value = !showOldPassword.value))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(IonIcon), {
                              icon: showOldPassword.value ? _unref(eyeOutline) : _unref(eyeOffOutline),
                              slot: "icon-only"
                            }, null, 8, ["icon"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonItem), { lines: "full" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonInput), {
                          id: "newPassword",
                          ref_key: "newPasswordInput",
                          ref: newPasswordInput,
                          modelValue: newPassword.value,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((newPassword).value = $event)),
                          label: _unref(translate)('New password'),
                          "label-placement": "stacked",
                          name: "newPassword",
                          type: showPassword.value ? 'text' : 'password',
                          "error-text": _unref(translate)('Password requirements not fulfilled.'),
                          autocomplete: "new-password",
                          onKeyup: validateNewPassword,
                          onIonBlur: _cache[3] || (_cache[3] = ($event: any) => (markTouched(newPasswordInput.value)))
                        }, null, 8, ["modelValue", "label", "type", "error-text"]),
                        _createVNode(_unref(IonButton), {
                          fill: "clear",
                          slot: "end",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (showPassword.value = !showPassword.value))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(IonIcon), {
                              icon: showPassword.value ? _unref(eyeOutline) : _unref(eyeOffOutline),
                              slot: "icon-only"
                            }, null, 8, ["icon"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonItem), { lines: "full" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonInput), {
                          id: "newPasswordVerify",
                          ref_key: "newPasswordVerifyInput",
                          ref: newPasswordVerifyInput,
                          modelValue: newPasswordVerify.value,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((newPasswordVerify).value = $event)),
                          label: _unref(translate)('Verify new password'),
                          "label-placement": "stacked",
                          name: "newPasswordVerify",
                          type: showConfirm.value ? 'text' : 'password',
                          "error-text": _unref(translate)('Passwords do not match.'),
                          autocomplete: "new-password",
                          onKeyup: validateNewPasswordVerify,
                          onIonBlur: _cache[6] || (_cache[6] = ($event: any) => (markTouched(newPasswordVerifyInput.value)))
                        }, null, 8, ["modelValue", "label", "type", "error-text"]),
                        _createVNode(_unref(IonButton), {
                          fill: "clear",
                          slot: "end",
                          onClick: _cache[7] || (_cache[7] = ($event: any) => (showConfirm.value = !showConfirm.value))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(IonIcon), {
                              icon: showConfirm.value ? _unref(eyeOutline) : _unref(eyeOffOutline),
                              slot: "icon-only"
                            }, null, 8, ["icon"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_unref(IonButton), {
                        color: "primary",
                        expand: "block",
                        disabled: isSubmitDisabled.value,
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (submit()))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(translate)("Reset password")) + " ", 1),
                          (isSubmitting.value)
                            ? (_openBlock(), _createBlock(_unref(IonSpinner), {
                                key: 0,
                                slot: "end",
                                name: "crescent"
                              }))
                            : (_openBlock(), _createBlock(_unref(IonIcon), {
                                key: 1,
                                slot: "end",
                                icon: _unref(arrowForwardOutline)
                              }, null, 8, ["icon"]))
                        ]),
                        _: 1
                      }, 8, ["disabled"])
                    ])
                  ]))
            ], 32)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})